<script setup lang="ts">

import { ref } from "vue";
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { Outcome } from '../../Types/LeadOptions';
import { Map } from '../../Types/Map';
import Icon from "@library/Components/Icon/Icon.vue";

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();
presentation.backgroundImage = '/images/sample/gkr-watermark.png';

const flipOffer = ref( false );

async function onSetOutcome( outcome: Outcome )
{

    lead.outcome = outcome;

    if( outcome == Outcome.thinkAboutIt )
    {
        presentation.goto( Map.OfferInformationEmail );
        return;
    }

    await lead.save();
    presentation.goto( Map.Close );

}

</script>

<template>

    <Page>

        <div class="flex flex-col gap-4 w-full items-center justify-center pt-14">

            <div class="w-[28rem] [perspective:100rem] mb-6 flex flex-col justify-center">
                <div class="cursor-pointer transform-gpu transition-transform duration-700 [transform-style:preserve-3d]"
                    :style="{ transform: flipOffer ? ' rotateY( 180deg )' : 'rotateY( 0 )' }"
                    @click="() => presentation.displayMedia( flipOffer ? '/Offer/special-offer.jpg' : '/Offer/standard-fees.jpg' )">
                    <Image src="/Offer/standard-fees.jpg" class="invisible" />
                    <div class="absolute inset-0 top-0 left-0 w-full h-full"
                        style="backface-visibility: hidden; transform: rotateY( 0 )">
                        <Image src="/Offer/standard-fees.jpg" class="rounded-lg shadow-xl" />
                    </div>
                    <div class="absolute inset-0 top-0 left-0 w-full h-full"
                        style="backface-visibility: hidden; transform: rotateY( 180deg )">
                        <Image src="/Offer/special-offer.jpg" class="rounded-lg shadow-xl" />
                    </div>
                </div>
            </div>

            <div class="flex gap-3 min-h-[4rem] items-start">

                <div class="basis-full flex items-center justify-center gap-3 grow flex-wrap">

                    <TouchButton
                        :variant="flipOffer ? 'button' : 'option'"
                        class="flex gap-2 !flex-row"
                        @click="() => flipOffer = !flipOffer">
                        Show Special Offer
                        <Icon name="reset" />
                    </TouchButton>

                    <div class="text-5xl px-4">&middot;</div>

                    <TouchButton
                        variant="button"
                        @click="() => onSetOutcome( Outcome.signup )">
                        Sign up
                    </TouchButton>

                    <TouchButton
                        variant="button"
                        flat
                        @click="() => onSetOutcome( Outcome.thinkAboutIt )">
                        I'll Think About It
                    </TouchButton>

                    <TouchButton
                        variant="button"
                        flat
                        @click="() => onSetOutcome( Outcome.notInterested )">
                        Not Interested
                    </TouchButton>

                </div>

            </div>

        </div>
    </Page>

</template>